module.exports = __webpack_public_path__ + "static/media/img-1.ec566e0c.jpg";